import * as Types from "@clockwise/schema";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type PatchSlackSettingsMutationMutationVariables = Types.Exact<{
  input: Types.PatchSlackSettingsMutationInput;
}>;

export type PatchSlackSettingsMutationMutation = {
  __typename: "Mutation";
  patchSlackSettings: {
    __typename: "PatchSlackSettingsMutationPayload";
    clientMutationId: string | null;
    slackSettings: {
      __typename: "SlackSettings";
      id: string;
      slackTeamId: string;
      slackUserId: string;
      calendarStatus: {
        __typename: "SlackCalendarStatusSync";
        calendarStatusEnabled: boolean;
        includeMeetingCategory: boolean;
        includeMeetingTitle: boolean;
      } | null;
      dailyDigestSettings: {
        __typename: "SlackDailyDigestSettings";
        enabled: boolean;
        timeSlot: Types.DigestTimeSlot;
      } | null;
      dndSettings: { __typename: "SlackDndSettings"; focusTime: boolean; meeting: boolean } | null;
      notificationSettings: {
        __typename: "SlackNotificationSettings";
        defragSummary: boolean;
      } | null;
    };
  } | null;
};

export const PatchSlackSettingsMutationDocument = ({
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "PatchSlackSettingsMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PatchSlackSettingsMutationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "patchSlackSettings" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: { kind: "Variable", name: { kind: "Name", value: "input" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clientMutationId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "slackSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "slackTeamId" } },
                      { kind: "Field", name: { kind: "Name", value: "slackUserId" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "calendarStatus" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "calendarStatusEnabled" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "includeMeetingCategory" },
                            },
                            { kind: "Field", name: { kind: "Name", value: "includeMeetingTitle" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dailyDigestSettings" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "enabled" } },
                            { kind: "Field", name: { kind: "Name", value: "timeSlot" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "dndSettings" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "focusTime" } },
                            { kind: "Field", name: { kind: "Name", value: "meeting" } },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "notificationSettings" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "defragSummary" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown) as DocumentNode<
  PatchSlackSettingsMutationMutation,
  PatchSlackSettingsMutationMutationVariables
>;
